<template>
  <div class="notice-content" ref="noticeWrapper">
    <div class="notice-content__hd">
      <slot name="hd" />
    </div>
    <div class="notice-content__body">
      <div class="t-noticebar__list t-noticebar__list--scrolling" ref="listDOM">
        <div
          class="t-noticebar__item"
          ref="itemDOM"
          :style="animateStyle"
          @transitionend="handleTransitionend()"
        >
          <span class="text">
            {{ text }}
          </span>
          <span class="text" v-if="scrollable">
            {{ text }}
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="js">
/* eslint-disable */
const speed = 30;
/** 小黄条-来自旧版狂赏印 */
export default {
  data() {
    return {
      scrollable: false,
      isMounted: false,
      state: {
        duration: 0,
        offset: 0,
        listWidth: 0,
        itemWidth: 0,
        timer: null,
        nextTimer: null,
      },
    };
  },
  props: {
    text: {
      type: String,
      default: '',
    },
    autoScroll: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    animateStyle() {
      return {
        transform: this.state.offset ? `translateX(${this.state.offset}px)` : '',
        transitionDuration: `${this.state.duration}s`,
        transitionTimingFunction: 'linear',
      };
    },
  },
  methods: {
    setTransform() {
      setTimeout(() => {
        this.state.offset = -this.state.itemWidth;
        this.state.duration = this.state.itemWidth / speed;
      }, 50);
    },
    handleTransitionend() {
      this.state.offset = 0;
      this.state.duration = 0;
      this.setTransform();
    },
    handleScrolling() {
      const setupDelay = 0;
      const delay = setupDelay && setupDelay > 0 ? setupDelay * 1000 : 0;
      const curSpeed = speed;

      setTimeout(() => {
        if (!this.scrollable) {
          return;
        }
        const { listDOM } = this.$refs;
        const { itemDOM } = this.$refs;
        // FIXME: getBoundingClientRect报错问题
        const listDOMWidth = listDOM.getBoundingClientRect().width / 2;
        const itemDOMWidth = itemDOM.getBoundingClientRect().width / 2;
        if (itemDOMWidth > listDOMWidth) {
          this.state.offset = -itemDOMWidth;
          this.state.duration = itemDOMWidth / curSpeed;
          this.state.listWidth = listDOMWidth;
          this.state.itemWidth = itemDOMWidth;
        }
      }, delay);
    },
    checkIsNeedScroll() {
      const { itemDOM, noticeWrapper } = this.$refs;
      const containerLength = noticeWrapper.scrollWidth;
      const textLength = itemDOM.scrollWidth;
      // 如果文字长度比container长，那么需要滚动
      return textLength > containerLength;
    },
  },
  mounted() {
    this.scrollable = this.autoScroll || this.checkIsNeedScroll();
    this.$nextTick(() => {
      this.handleScrolling();
    });
  },
};
</script>
<style scoped lang="less">
@rem: 200rem;

.notice-content {
  display: flex;
  flex-direction: row;
  align-items: center;
  // padding: 13px 16px;
  .notice-content__hd {
    display: block;
    box-sizing: border-box;
    .t-icon {
      fill: currentColor;
      display: block;
      color: #fff;
      font-size: 40 / @rem;
      width: 40 / @rem;
      height: 40 / @rem;
    }
  }
  .notice-content__body {
    flex: 1;
    overflow: hidden;
    .t-noticebar__list--scrolling {
      position: relative;
      z-index: 1;
      min-height: 40 / @rem;
      overflow: hidden;
    }
    .t-noticebar__item {
      position: absolute;
      top: 0;
      left: 0;
      z-index: 100;
      line-height: 40 / @rem;
      display: flex;
      flex-direction: row;
      span {
        white-space: nowrap;
        overflow: hidden;
        display: inline-block;
      }
      .text:not(:first-child) {
        padding-left: 10 / @rem;
      }
    }
  }
}
</style>
